var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tabs',{attrs:{"value":"list"},on:{"on-click":_vm.onClickTab}},[_c('TabPane',{attrs:{"label":"列表质检","name":"list"}},[_c('list-check',{ref:"list"})],1),_c('TabPane',{attrs:{"label":"大图质检","name":"picture"}},[_c('picture-check',{ref:"picture"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }